// src/components/FloorPlanGenerator/AIKeyInput.js
import React, { useState } from 'react';

const AIKeyInput = ({ onSubmit, error }) => {
  const [key, setKey] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(key);
  };

  return (
    <div className="ai-key-input">
      <h3>Enter Groq API Key</h3>
      <form onSubmit={handleSubmit}>
        <div className="input-group">
          <input
            type="password"
            value={key}
            onChange={(e) => setKey(e.target.value)}
            placeholder="Enter your Groq API key"
            className="api-key-input"
            required
          />
        </div>
        {error && <div className="error-message">{error}</div>}
        <button type="submit" className="action-button">
          Initialize AI Service
        </button>
      </form>
      <p className="api-key-info">
        You can get your Groq API key from{' '}
        <a href="https://console.groq.com/keys" target="_blank" rel="noopener noreferrer">
          Groq Console
        </a>
      </p>
    </div>
  );
};

export default AIKeyInput;